import VerticalBarChart from './VerticalBarChart';
import UIBuilder from '../BaseComponent';
import { UI_COMPONENTS_TYPE_FIELD } from '../../../../Constant/Constant';

export default class VerticalBarChartBuilder extends UIBuilder {
  constructor() {
    super();
    this.schema = {
      data: UI_COMPONENTS_TYPE_FIELD.JSON,
    };
  }

  getType = () => {
    return 'vertical_bar_chart';
  };

  getComponent = () => {
    return VerticalBarChart;
  };
}
